/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function VideoIdHero(elem) {
        Behaviors.init(VideoIdHero, this, arguments);
        var $thisElem = this.$elem;

        
    }
    Behaviors.inherit(VideoIdHero, Behaviors.Behavior);
    VideoIdHero.QUERY = "[data-VideoIdHero]";
    VideoIdHero.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(VideoIdHero);
    module.VideoIdHero = VideoIdHero;
    return module;
}(window.jQuery, window.Behaviors));
